module.exports = __webpack_public_path__ + "img/guitar.6c30b122.svg";